import { useEffect, useRef } from 'react';
import { Row, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Devices from '../../components/blocks/devices';
import Filters from '../../components/blocks/filters';
import ScansDaytime from '../../components/blocks/scansDaytime';
import ScansLocation from '../../components/blocks/scansLocation';
import Title from '../../components/blocks/title';
import TotalScans from '../../components/blocks/totalScans';
import TotalUsersChart from '../../components/blocks/totalUsersChart';
import UniqueUsers from '../../components/blocks/uniqueUsers';
import UniqueUsersChart from '../../components/blocks/uniqueUsersChart';
import { setPreloader } from '../../redux/slices/preloader';
import DownloadCsv from '../../components/blocks/downloadCsv';
import useUrlParams from '../../hooks/useUrlParams';
import { setFilters } from '../../redux/slices/filters';
import GlobalWidgets from '../../components/globalWidgets';
import { setPdfContentRef } from '../../hooks/usePdfDownload';

const GeneratingQrCodePage = () => {
  const { dataLoad, isStatisticCollecting, statisticPath, filters } =
    useSelector((state) => ({
      dataLoad: state.preloader.dataLoad,
      isStatisticCollecting: state.meQrData.isStatisticCollecting,
      statisticPath: state.meQrData.statisticPath,
      filters: state.filters
    }));

  const dispatch = useDispatch();
  const { id } = useUrlParams();
  const contentRef = useRef(null);

  useEffect(() => {
    setPdfContentRef(contentRef);
    return () => setPdfContentRef(null);
  }, []);

  useEffect(() => {
    dispatch(setPreloader(Object.values(dataLoad).some((item) => item)));
  }, [dispatch, dataLoad]);

  useEffect(() => {
    if (id) {
      dispatch(
        setFilters({
          ...filters,
          qrIds: [Number(id)],
          mode: 'period',
          isFitersActive: true
        })
      );
    }
    // eslint-disable-next-line
  }, [id]);

  if (id && filters.qrIds.length === 0) {
    return null;
  }

  return (
    <div className="gen-qr">
      <GlobalWidgets />
      {(statisticPath || isStatisticCollecting) && <DownloadCsv />}
      <Container ref={contentRef}>
        <Row className="g-4 mb-5">
          <div data-pdf-exclude>
            <Title />
            <Filters withParentConfirmation />
          </div>
          <TotalScans />
          <UniqueUsers />
          <TotalUsersChart />
          <UniqueUsersChart />
          <ScansDaytime />
          <ScansLocation />
          <Devices />
        </Row>
      </Container>
    </div>
  );
};

export default GeneratingQrCodePage;
